/**
 * `AW4` — el borde de lectura de conversaciones, disponible para el árbol.
 *
 * Mismo patrón que `contexto-borde-participantes.tsx` y por la misma razón de
 * fondo: la tabla de conversaciones lo necesita y está a varios niveles de la
 * raíz, así que la alternativa es plomería por props a través del montaje. Hay
 * una segunda razón y es la que importa: **inyectado, el borde se puede
 * reemplazar por un doble.** La pantalla se puede ejercer contra un doble en
 * memoria, sin base, sin red y sin el módulo real — y eso sólo es posible si el
 * borde entra por afuera. Un `crearBordeConversacionesHttp()` llamado adentro
 * del componente haría que la única forma de probarlo fuera interceptar
 * `fetch`.
 */

import { createContext, useContext } from "react"
import type { BordeConversaciones } from "./conversaciones/borde-conversaciones.ts"

/**
 * Sin valor por defecto, igual que la configuración y el borde de escritura de
 * documentos.
 *
 * Un doble por defecto acá haría que un componente montado fuera del proveedor
 * anduviera igual, escribiendo en el aire. Falla en el primer render.
 */
const ContextoBordeConversaciones = createContext<BordeConversaciones | null>(null)

export const ProveedorBordeConversaciones = ContextoBordeConversaciones.Provider

export function useBordeConversaciones(): BordeConversaciones {
  const borde = useContext(ContextoBordeConversaciones)
  if (borde === null) {
    throw new Error(
      "useBordeConversaciones() se llamó fuera de <ProveedorBordeConversaciones>. El borde se arma en App.tsx con la configuración ya leída.",
    )
  }
  return borde
}
